import classnames from "classnames";
import { t } from "@/i18n-js/instance";
import type { QuizAttempt } from "@/react/types/QuizAttempt";
import { Typography } from "@circle-react-uikit/Typography";

export const ResultCell = ({ attempt }: { attempt: QuizAttempt }) => {
  if (attempt.result === "pending") {
    return <>{t("n/a")}</>;
  }
  return (
    <span
      className={classnames("rounded-md px-2 py-1", {
        "bg-v2-success-100": attempt.result === "passed",
        "bg-v2-danger-100": attempt.result === "failed",
      })}
    >
      <Typography.LabelSm
        weight="semibold"
        color={
          attempt.result === "passed" ? "text-v2-success" : "text-v2-danger"
        }
      >
        {t(
          `courses.admin_summary.engagement.quiz_results.results.${attempt.result}`,
        )}
      </Typography.LabelSm>
      {}
    </span>
  );
};
